<template>
  <div class="overflow-auto">
    <vs-table :data="paymentRounds">
      <template slot="thead">
        <vs-th>งวด</vs-th>
        <vs-th>วันที่ชำระ</vs-th>
        <vs-th>จำนวนวัน</vs-th>
        <vs-th>ยอดผ่อนชำระ</vs-th>
        <vs-th>ชำระดอกเบี้ย</vs-th>
        <vs-th>ชำระเงินต้น</vs-th>
        <vs-th>เงินต้นคงเหลือ</vs-th>
        <vs-th>ชำระยอดยกมา</vs-th>
        <vs-th>ยอดยกมาคงเหลือ</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="item in data" :key="item.no">
          <vs-td>{{ item.no }}</vs-td>
          <vs-td>{{ item.date }}</vs-td>
          <vs-td>{{ item.days }}</vs-td>
          <vs-td>{{ item.paymentRoundAmount }}</vs-td>
          <vs-td>{{ item.paymentInterest }}</vs-td>
          <vs-td>{{ item.paymentPrincipal }}</vs-td>
          <vs-td>{{ item.principalRemain }}</vs-td>
          <vs-td>{{ item.paymentRestructuring }}</vs-td>
          <vs-td>{{ item.restructuringRemain }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: 'PaymentScheduleTable',
  props: {
    paymentRounds: {type: Array, required: true}
  }
}
</script>
